import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
import { withRouter } from 'react-router-dom';

import TopMenu from '../../../component/dashboard/TopMenu';
import AccountMyProfile from '../../../component/account/AccountMyProfile';

class AccountContainer extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    history: PropTypes.shape({
      location: PropTypes.object.isRequired,
      push: PropTypes.func.isRequired,
    }),
  };

  static defaultProps = {
    basePath: '/dashboard/account/',
  };

  render() {
    let topMenuItems = [
      {
        name: 'my-profile',
        label: 'My Profile',
      },
    ];

    return (
      <div className="account-container">
        <label className="page-header">My Account</label>
        <TopMenu items={topMenuItems} basePath={this.props.basePath} />
        <Switch>
          <Route
            exact
            path="/dashboard/account"
            render={() => <Redirect to="/dashboard/account/my-profile" />}
          />
          <Route
            path="/dashboard/account/my-profile"
            render={() => <AccountMyProfile {...this.props.user} />}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.account.user,
});

export default withRouter(connect(mapStateToProps)(AccountContainer));



// WEBPACK FOOTER //
// ./src/container/dashboard/AccountContainer/index.js